module.exports = require('./lib/index');



//////////////////
// WEBPACK FOOTER
// ./~/_symbol-observable@1.0.4@symbol-observable/index.js
// module id = 192
// module chunks = 1